<template>
  <el-table
    :data="inoutOrders"
    border
    style="width: 100%"
    class="table"
  >
    <el-table-column
      prop="csName"
      :label="$t('chainInoutOrder.supplier')"
      align="center"
    />
    <el-table-column
      prop="orderId"
      :label="$t('chainInoutOrder.orderId')"
      align="center"
    />
    <el-table-column
      prop="stateName"
      :label="$t('chainInoutOrder.status')"
      align="center"
    />
    <el-table-column
      prop="personName"
      :label="$t('chainInoutOrder.contactPerson')"
      align="center"
    />
    <el-table-column
      prop="tel"
      :label="$t('chainInoutOrder.contactPhone')"
      align="center"
    />
    <el-table-column
      :label="$t('chainInoutOrder.operation')"
      align="center"
    >
      <template #default="scope">
        <el-button
          size="mini"
          @click="handleDetail(scope.row)"
        >
          {{ $t('chainInoutOrder.detail') }}
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'ChainInoutOrderTable',
  props: {
    inoutOrders: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleDetail(order) {
      this.$emit('to-order-detail', order)
    }
  }
}
</script>

<style scoped>
.table {
  margin-bottom: 20px;
}
</style>